/* eslint-disable */
import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  container: {
    height: 10,
    position: 'absolute',
    bottom: 10,
    right: 10,
    // backgroundColor: 'green',
    flex: 1,
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
  },
  direction: {
    height: 12,
    width: 12,
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    marginRight: 5,
  },
})
